import { Component, Input } from '@angular/core';

import { ActionPlan } from 'app/providers/storage-api/actionplan.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-action-plan-details-progress-tab',
  templateUrl: './action-plan-details-progress-tab.component.html',
  styleUrls: ['./action-plan-details-progress-tab.component.scss'],
  standalone: false,
})
export class ActionPlanDetailsProgressTabComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() actionPlan: ActionPlan;
}
